import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class QrComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentQr | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.disabled = settings?.disabled ?? false;
		this.input = false;
		this.options = {
			color: {
				dark: '#000000',
				light: '#ffffff',
			},
			errorCorrectionLevel: 'M',
			margin: 4,
			scale: 4,
			small: false,
			...settings?.options,
		};
		this.validate = {
			card: new Card(settings?.validate?.card ?? '0-1'),
			custom: settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
		};
	}
}